/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CalculateWirePaymentFeeDto } from '../models/CalculateWirePaymentFeeDto';
import type { CreateWithdrawalBaseDto } from '../models/CreateWithdrawalBaseDto';
import type { CreateWithdrawalDto } from '../models/CreateWithdrawalDto';
import type { ValidateWithdrawalLimitDto } from '../models/ValidateWithdrawalLimitDto';
import type { WireTransferFeeDto } from '../models/WireTransferFeeDto';
import type { WireTransferFeeDtoV2 } from '../models/WireTransferFeeDtoV2';
import type { WithdrawalParamsDto } from '../models/WithdrawalParamsDto';
import type { WithdrawalRecentBankDetailsDto } from '../models/WithdrawalRecentBankDetailsDto';
import type { WithdrawalRequestDetailsDto } from '../models/WithdrawalRequestDetailsDto';
import type { WithdrawalRequestDto } from '../models/WithdrawalRequestDto';
import type { CancelablePromise } from '../../../core/CancelablePromise';
import type { BaseHttpRequest } from '../../../core/BaseHttpRequest';
export class WithdrawalsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @deprecated
     * @returns WithdrawalParamsDto Success
     * @throws ApiError
     */
    public getApiWithdrawalsParams(): CancelablePromise<WithdrawalParamsDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/withdrawals/params',
        });
    }
    /**
     * @param requestBody
     * @returns WireTransferFeeDto Success
     * @throws ApiError
     */
    public postApiWithdrawalsLimit(
        requestBody?: ValidateWithdrawalLimitDto,
    ): CancelablePromise<WireTransferFeeDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/withdrawals/limit',
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns WireTransferFeeDtoV2 Success
     * @throws ApiError
     */
    public postApiWithdrawalsFee(
        requestBody?: CalculateWirePaymentFeeDto,
    ): CancelablePromise<WireTransferFeeDtoV2> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/withdrawals/fee',
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @deprecated
     * @param requestBody
     * @returns WithdrawalRequestDto Created
     * @throws ApiError
     */
    public postApiWithdrawals(
        requestBody?: CreateWithdrawalDto,
    ): CancelablePromise<WithdrawalRequestDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/withdrawals',
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @returns WithdrawalRequestDto Success
     * @throws ApiError
     */
    public getApiWithdrawals(): CancelablePromise<WithdrawalRequestDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/withdrawals',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @deprecated
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public postApiWithdrawalsSmsConfirmations(
        requestBody?: CreateWithdrawalBaseDto,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/withdrawals/sms-confirmations',
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                429: `Too Many Requests`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param id
     * @returns WithdrawalRequestDetailsDto Success
     * @throws ApiError
     */
    public getApiWithdrawals1(
        id: number,
    ): CancelablePromise<WithdrawalRequestDetailsDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/withdrawals/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param requestId
     * @returns WithdrawalRequestDto Success
     * @throws ApiError
     */
    public postApiWithdrawalsCancel(
        requestId: number,
    ): CancelablePromise<WithdrawalRequestDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/withdrawals/{requestId}/cancel',
            path: {
                'requestId': requestId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param currency
     * @returns WithdrawalRecentBankDetailsDto Success
     * @throws ApiError
     */
    public getApiWithdrawalsRecentBankDetails(
        currency?: string,
    ): CancelablePromise<WithdrawalRecentBankDetailsDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/withdrawals/recent-bank-details',
            query: {
                'currency': currency,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
    }
}
